import { BaseSelectItem } from 'wbs-components-lib';

import { VipTaskItemStatusesEnum, VipTaskTypesEnum } from '@shared/constants';
import { VipTaskModel, VipTaskUserItemModel } from '@shared/types';

export const prepareTaskItemsToBaseSelect = (taskItems: VipTaskUserItemModel[]) =>
  taskItems.map((task) => ({
    id: task.id,
    value: task.title,
  }));

export const prepareTasksToBaseSelect = (tasks: VipTaskModel[]) =>
  tasks.reduce((selectItems, task) => {
    if (task.type === VipTaskTypesEnum.PARTNER) {
      selectItems.push({
        id: task.id,
        value: task.title,
      });
    }

    return selectItems;
  }, [] as BaseSelectItem[]);

export const prepareTaskItemStatusesToBaseSelect = () =>
  Object.keys(VipTaskItemStatusesEnum).reduce(
    (acc, key) => {
      const status = VipTaskItemStatusesEnum[key as keyof typeof VipTaskItemStatusesEnum];

      if (isNaN(Number(key))) {
        acc.push({
          id: status,
          value: key,
        });
      }

      return acc;
    },
    [] as Array<{ id: number; value: string }>
  );
